module.exports = __webpack_public_path__ + "static/img/1_1_1_3.e4a57bff.jpg";